export default "__VITE_ASSET__QOtryJyk__"